var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbundance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.464 0H.536C.239 0 0 .305 0 .682v13.636c0 .377.24.682.536.682h13.928c.297 0 .536-.305.536-.682V.682C15 .305 14.76 0 14.464 0Zm-.67 4.432h-3.549V1.534h3.55v2.898Zm0 4.773h-3.549v-3.41h3.55v3.41Zm-7.968-3.41h3.348v3.41H5.826v-3.41Zm3.348-1.363H5.826V1.534h3.348v2.898ZM1.205 5.795h3.55v3.41h-3.55v-3.41Zm0-4.26h3.55v2.897h-3.55V1.534Zm0 9.033h3.55v2.898h-3.55v-2.898Zm4.62 0h3.35v2.898h-3.35v-2.898Zm7.97 2.898h-3.55v-2.898h3.55v2.898Z",
    fill: "#999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbundance);
export default __webpack_public_path__ + "static/media/abundance.4fd091d9f539813e7dd59323f4d78f1a.svg";
export { ForwardRef as ReactComponent };